import { Controller } from '@hotwired/stimulus'

// The comment-thread toggle's live unread dot (shared/comments/_thread_toggle).
// The Comment model broadcasts a `comments-thread:comment-added` event on every
// new comment; each client shows the dot for other people's comments while its
// drawer is closed, and recounts the drawer's unread cards when it closes.
export default class extends Controller {
  static outlets = ['wip--side-bar']
  static targets = ['badge']
  static values = {
    currentUserId: Number,
    commentableId: Number
  }

  // A `sidebar=open` link renders the drawer already open, so no open event fires.
  wipSideBarOutletConnected() {
    if (this.drawerOpen) this.toggleBadge(false)
  }

  commentAdded(event) {
    const { authorId, commentableId } = event.detail || {}
    if (commentableId !== this.commentableIdValue) return
    if (authorId === this.currentUserIdValue) return
    if (this.drawerOpen) return // the reader is looking at the thread; the close recount decides

    this.toggleBadge(true)
  }

  sidebarOpened(event) {
    if (!this.ownSidebar(event)) return

    this.toggleBadge(false)
  }

  // Reading happens inside the drawer (the read tracker marks cards as the user
  // scrolls them into view), so closing it is the moment the dot can be settled.
  sidebarClosed(event) {
    if (!this.ownSidebar(event)) return

    const unread = this.wipSideBarOutlet.element.querySelectorAll(
      '[data-comments--read-tracker-is-unread-value]:not([data-marked-as-read="true"])'
    )
    this.toggleBadge(unread.length > 0)
  }

  toggleBadge(show) {
    if (!this.hasBadgeTarget) return

    this.badgeTarget.classList.toggle('d-none', !show)
  }

  get drawerOpen() {
    return this.hasWipSideBarOutlet && this.wipSideBarOutlet.isOpen()
  }

  // Other sidebars on the page (e.g. the layout-level time-study drawer) also
  // dispatch the open/close events — only react to our own drawer.
  ownSidebar(event) {
    if (!this.hasWipSideBarOutlet) return false

    return !event?.detail?.sidebar || event.detail.sidebar === this.wipSideBarOutlet.element
  }
}
